<template lang="html">
<div>
        <div class="headLine">用户审核</div>
      <div class="subpage ent_edit">
            <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
                
                <div class="selects">
                    <div class="select-line">

                          <div class="selectGp">
                                <span class="cName">姓名</span>
                                <el-form-item prop="name">
                                    <el-input class="inpText" size="medium" v-model="params.name" :disabled="true" placeholder="请输入姓名"></el-input>
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span class="cName">手机号</span>
                                <el-form-item prop="phone">
                                    <el-input class="inpText" size="medium" v-model="params.phone" :disabled="true" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span class="cName">邮箱</span>
                                <el-form-item prop="phone">
                                    <el-input class="inpText" size="medium" v-model="params.email" :disabled="true" placeholder=""></el-input>
                                </el-form-item>
                          </div>

                      </div>
                     <div class="select-line">
                         <div class="selectGp">
                                <span class="cName">所在街乡</span>
                                <el-form-item prop="jiexiang">
                                    <el-input class="inpText" size="medium" v-model="params.jiexiang" :disabled="true" placeholder=""></el-input>
                                </el-form-item>
                          </div>
                         <div class="selectGp">
                                <span class="cName">所在单位</span>
                                <el-form-item prop="danwei">
                                    <el-input class="inpText" size="medium" v-model="params.danwei" :disabled="true" placeholder=""></el-input>
                                </el-form-item>
                          </div>

                          <div v-if="params.type!=2" class="selectGp">
                                <span class="cName">所属功能区</span>
                                <el-form-item prop="ownePark">
                                    <el-input class="inpText" size="medium" v-model="params.ownePark" :disabled="true" placeholder=""></el-input>
                                </el-form-item>
                          </div>
                         </div>
                      

                      <div class="select-line">

                          <div class="selectGp">
                                <span class="cName">机构</span>
                                
                                <el-form-item prop="organizationId">
                                    <el-cascader
                                    collapse-tags
                                    clearable
                                    class="inpText"
                                    size="medium"
                                    v-model="params.organizationId"
                                    :placeholder="plaText"
                                    :options="orgArr"
                                    :show-all-levels="false"
                                    :props="{value:'id',label:'name',children:'getCompanyPostModules',multiple:false,emitPath:false }"
                                    @change="selectTreeChange">
                                </el-cascader>
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span class="cName">权限</span>
                                <el-form-item prop="rulePostId">
                                     <el-select class="inpText" clearable="clearable" size="medium" @change="selectChange" v-model="params.rulePostId" >
                                        <el-option
                                            v-for="item in selectArr"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                          </div>

                          
                          
                      </div>
                      <div class="select-line">
                          <div class="selectGp">
                                <span class="cName">审核</span>
                                 <el-form-item prop="status">
                                    <el-radio-group v-model="params.status">
                                        <el-radio label="1">通过</el-radio>
                                        <el-radio label="2">不通过</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                          </div>
                       </div>   
                     
                </div>
            </el-form>

      </div>
      <div class="btnLine">
          <el-button @click="review()" type="danger" size="small">审核</el-button>
          <el-button @click="pageBack" size="small">返回</el-button>
    </div>
</div>
</template>

<script>
import { getUserRegisterById ,getPostList,getGmpTree,saveUserRegister} from "@/api/pgMent/userMent";
var _status = function(rule,val,callback){
		if(val==0){
            callback(new Error('请选择审核状态'));
		}else if(reg.test(val)){
            callback();
		}
	};
export default {
    props:['entid'],
    filters:{
        transPhone:function(e){
            return e.substr(0,3) + '****' + e.substr(8,11);
        }
    },
    data(){
        return{
            mebId:'',
            mebList:[],
            orgArr:[],
            orgMap:{},
            selectArr:[],
            params:{
                code: '',
                danwei: '',
                email: '',
                id: '',
                message: '',
                name: '',
                operationUser: '',
                operationUserId: '',
                organization: '',
                organizationId: '',
                ownePark: '',
                phone: '',
                rulePost: '',
                rulePostId: '',
                status: 0,
                userId: '',
                type:0,
                jiexiang:'',
                jiexiangid:'',
            },
            rules:{
                // name:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
                // phone:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
                // danwei:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
                // email:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
                // ownePark:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
                organizationId:[{
                   required: true,
                   trigger: 'blur'
                }],
                rulePostId:[{
                   required: true,
                   trigger: 'blur'
                }],
                status:[{
                   required: true, 
                   trigger: 'blur'
                }],
                
            }
        }
    },
    methods:{
        
        selectTreeChange:function(e){
            console.log(e);
            if(e){
                this.params.organizationId=e;
            }else{
                this.params.organizationId='';
            }
            
        },
        selectChange:function(e){
            console.log(e);
            if(e){
                this.params.rulePostId=e;
            }else{
                this.params.rulePostId='';
            }
            
        },
        pageBack:function(){
            this.$router.go(-1);
        },
        review:function(){
            var userInfo = this.$store.getters.userInfo;
            this.params.operationUserId=userInfo.userId;
            this.params.operationUser=userInfo.userName;
  
            this.saveReturn();
        },
        initData:function(id){
            var vues = this;
            getUserRegisterById({'id':id}).then(res => {
                vues.params=res.userRegister;
            })
        },
        mapCreate(arr){
            let vues = this;
            
            arr.forEach(item => {
                vues.orgMap[item.id] = item.name;
                if(item.getCompanyPostModules.length > 0){
                   vues.mapCreate(item.getCompanyPostModules);
                }else{
                   delete item.getCompanyPostModules;
                }
            })
            return arr;
        },
        saveReturn:function(){
            var vues = this;
            if(this.params.status==0){
                vues.$message.error('请选择审核状态');
                return;
            }
            return new Promise((reslove,reject) => {
                vues.$refs.ruleForm.validate((valid) => {
                    // console.log(vues.params);
                    if(valid){
                         
                        saveUserRegister({'userRegister':vues.params}).then(res=>{
                            this.$message({
                                  showClose:true,
                                  message:'操作成功！',
                                  type:'success'
                              });
                            this.$router.go(-1);
                        });
                    }else{
                        
                    }
                })
            })
        }
    },
    created:function(){
        var querys = this.$route.query;
        var vues = this;
        console.log(querys);
        
        getUserRegisterById({'id':querys.id}).then(res => {
            vues.params=res.userRegister;
            getGmpTree().then(res=>{
                vues.mapCreate(res.getCompanyPostTreeModules);
                vues.orgArr =res.getCompanyPostTreeModules;
            });
            getPostList({type:6}).then(res=>{
                console.log(res.getPostListModules);
                vues.selectArr=res.getPostListModules;
            });
            
        });
    }
}
</script>

<style lang="scss" scoped>

.selects{
   .select-line{
     position: relative;
     margin-bottom: 30px;
     margin-top: 30px;
     .selectGp{
       display: inline-block;
       width: 32%;
       span{
         font-size: 15px;
         margin-right: 12px;
       }

       .cName{
          display: inline-block;
          width: 60px;
       }
     }
   }
}
.headLine{
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #EBEEF5;
}
.text-block{
      font-size: 15px;
      margin-bottom: 20px;
     .bName{
          width: 60px;
          float: left;
          margin-top: 9px;
     }
     .bContent{
          margin-left: 76px;
          position: relative;
     }
}

.title-block{
     width: 32%;
     margin-top: 12px;
}


.img-block{
   margin-top:30px;
}

.radio-block{
   margin-top: 60px;
}

.tag-block{
   margin-top:45px;
   .bName{
        margin-top: 6px;
   }
}

.check-block{
   margin-top: 30px;
   .check-seek {
       .seek-head{
           position: relative;
           .el-icon-search{
               position: absolute;
               left: 15px;
               top: 12px;
               color: #dcdfe6;
               z-index: 2;
           }
           .el-select{
              width: 432px;
           }
       }
       .seek-body{
            .el-tag{
                margin-right: 12px;
                margin-top: 12px;
            }
       }
   }
}

.enclosure{
   margin-top: 60px;
  .ttl{
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent{
    margin-left: 75px;
  }

}
.btnLine{
        margin-top: 20px;
        padding-left: 20px;
        .el-button{
            width: 90px;
        }
    }

</style>

<style lang="css">

.subpage.ent_edit{
    padding: 30px;
}
.subpage.ent_edit .el-input__inner{
  border-radius: 0px !important;
}

.subpage.ent_edit .selects .el-input{
  width: 240px !important;
}

.subpage.ent_edit .el-form-item{
  display: inline-block !important;
  margin-bottom: 0px;
}

</style>



// WEBPACK FOOTER //
// userReview.vue?65c12352